import { render, staticRenderFns } from "./colorfulCheckbox.vue?vue&type=template&id=8bbc56ba"
import script from "./colorfulCheckbox.vue?vue&type=script&lang=js"
export * from "./colorfulCheckbox.vue?vue&type=script&lang=js"
import style0 from "./colorfulCheckbox.vue?vue&type=style&index=0&id=8bbc56ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports